module.exports = __webpack_public_path__ + "media/universities/ParisTech-44292308.png";